import { httpPostJson } from '@treatwell/ui';
import { cachifyPromise } from 'cachify-promise';

export type SalesforceTokensResponse = {
  chatSessionToken: string;
  profileAccessToken: string;
};
export function composeRequestSalesforceTokens(baseUrl = '') {
  const requestSalesforceTokens = () => {
    return httpPostJson<SalesforceTokensResponse>({
      path: `${baseUrl}/api/v2/salesforce/chat-token`,
    });
  };
  return cachifyPromise(requestSalesforceTokens, { ttl: 300000 /* 5 min */ });
}

export const requestSalesforceTokens = composeRequestSalesforceTokens();
